import React from 'react';

type SortBySelectItem = {
  value: string;
  label: string;
};

type SortBySelectProps = {
  items: Array<SortBySelectItem>;
  currentValue?: string;
  onClick: () => void;
  onChange: (value: string, label: string) => void;
};

export const SortBySelect = ({ items, currentValue, onClick, onChange }: SortBySelectProps) => (
  <select
    className="ais-sortByCustom"
    onClick={onClick}
    onChange={e => onChange(e.target.value, e.target.options[e.target.selectedIndex].innerText)}
    value={currentValue}
  >
    {items.map((item, index) => (
      <option value={item.value} key={index}>
        {item.label}
      </option>
    ))}
  </select>
);
